import React from "react";

//Material Icons
import { ArrowForwardIos } from "@mui/icons-material";

//UI Material
import { Button, TableCell, TableRow, Typography } from "@mui/material";

export default function QuoteRow({ quote }) {
  // ==========> Component Functions<==========
  //Function to generate the products of the quote
  const generateQuoteProducts = (products) => {
    let string = "";
    for (const product of products) {
      string += product.productName + ", ";
    }
    string = string.slice(0, -2) + "";

    return string;
  };

  // ==========> Component <==========
  return (
    <TableRow>
      <TableCell align="center">
        <Typography>{quote.quoteNumber}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ width: "300px" }}>
        <Typography>{quote.client.name}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ width: "300px" }}>
        <Typography variant="body2">
          {generateQuoteProducts(quote.products)}
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Typography>
          {new Date(quote.createdAt).toLocaleDateString()}
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Typography>
          {new Date(quote.expirationDate).toLocaleDateString()}
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Button
          endIcon={<ArrowForwardIos />}
          href={`/quote?id=${quote.quoteNumber}`}
        >
          Ver más
        </Button>
      </TableCell>
    </TableRow>
  );
}
